// extracted by mini-css-extract-plugin
export var header = "_5r-0";